var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.bb627220d61a346426376a1c2cafc8ad.svg#n';
                    var viewUrl = 'sprites.bb627220d61a346426376a1c2cafc8ad.svg#view-n';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 238.003 238.003',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };